module.exports = __webpack_public_path__ + "static/assets/b0255c314f3410e6207fb505d9d04ba8.gif";